import { ServerException } from '../../../Booking/actions/constants';
import { HttpStatusCodes } from '../../../Booking/constants';
import getMonolithHost from '../../../utils/getMonolithHost';

const apiHost = getMonolithHost();
export default function fetchPatientInformation({ fetchFunc }) {
    return fetchFunc(`${apiHost}/api/patient/v1/current/details`).then(
        (response) => {
            if (response.status !== HttpStatusCodes.OK) {
                throw new ServerException({ response });
            }
            return response.json();
        }
    );
}
